import { SVGProps } from "react";

const JpgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="32"
    fill="none"
    viewBox="0 0 34 32"
  >
    <path
      fill="#fff"
      d="M15.02.375h4.8c.775 0 1.52.3 2.08.837l5.137 4.931v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375"
    ></path>
    <path
      stroke="#E6E6E6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.751"
      d="M27.037 6.143v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375h4.8c.775 0 1.52.3 2.08.837zm0 0h-3.004a3.004 3.004 0 0 1-3.005-3.004V.736"
    ></path>
    <g filter="url(#a)">
      <rect
        width="15.772"
        height="6.253"
        x="9.012"
        y="8.633"
        fill="#FA824C"
        rx="1.878"
        shapeRendering="crispEdges"
      ></rect>
      <path
        fill="#fff"
        d="M12.94 9.661h.617v2.905q0 .393-.156.674-.155.28-.434.428a1.4 1.4 0 0 1-.656.146q-.346 0-.622-.126a1 1 0 0 1-.434-.366 1.05 1.05 0 0 1-.159-.588h.615a.54.54 0 0 0 .078.294.55.55 0 0 0 .218.194q.14.068.32.068.195 0 .332-.082a.53.53 0 0 0 .21-.246 1 1 0 0 0 .072-.396zm1.742 4.097V9.66h1.46q.478 0 .792.174t.47.476q.156.3.156.676 0 .379-.158.68-.156.301-.472.476t-.79.175h-1.004v-.524h.948q.302 0 .49-.104a.65.65 0 0 0 .276-.289.94.94 0 0 0 .088-.414.9.9 0 0 0-.088-.412.63.63 0 0 0-.278-.282 1.04 1.04 0 0 0-.496-.102H15.3v3.567zm6.6-2.803a1.3 1.3 0 0 0-.155-.326 1 1 0 0 0-.536-.406 1.2 1.2 0 0 0-.375-.054q-.345 0-.624.178a1.2 1.2 0 0 0-.44.522q-.16.342-.16.838 0 .498.162.843.162.344.444.522.283.177.643.178.333 0 .582-.136a.95.95 0 0 0 .386-.384q.138-.25.138-.588l.16.03h-1.172v-.51h1.61v.465q0 .517-.22.897a1.5 1.5 0 0 1-.604.584q-.385.206-.88.206-.557 0-.977-.256a1.74 1.74 0 0 1-.652-.726q-.234-.473-.234-1.12 0-.49.136-.88t.382-.663q.249-.274.582-.418.337-.146.734-.146.333 0 .619.098.287.098.512.278a1.57 1.57 0 0 1 .574.974z"
      ></path>
    </g>
    <defs>
      <filter
        id="a"
        width="33.799"
        height="24.275"
        x="-0.001"
        y="7.131"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="2.253"
          result="effect1_dropShadow_56554_62134"
        ></feMorphology>
        <feOffset dy="7.511"></feOffset>
        <feGaussianBlur stdDeviation="5.633"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_56554_62134"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="3.004"
          result="effect2_dropShadow_56554_62134"
        ></feMorphology>
        <feOffset dy="3.004"></feOffset>
        <feGaussianBlur stdDeviation="2.253"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="effect1_dropShadow_56554_62134"
          result="effect2_dropShadow_56554_62134"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_56554_62134"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);
export default JpgFile;
